import { forEach, isEmpty, isNil } from 'lodash';
import { booleanDefine } from '@/utils/boolean';

/**
 * 동적 트리 Mixin
 * @author Ju
 */
export default {
  data() {
    return {
      dynamicFlag: true,
      rootLoading: false,
      loading: false,
      searchKeyword: null,
    };
  },
  methods: {
    /**
     * 동적 트리 기본 파라미터 객체를 반환한다.
     * @author Ju
     * @return {Object} 파라미터 객체
     */
    getBaseParams(node) {
      const params = {
        dynamicFlag: booleanDefine.TRUE_Y,
      };
      if (node.level !== 0) {
        params.parentTreeKey = node.data.treeKey;
      }
      if (!isNil(this.searchKeyword) && this.searchKeyword !== '') {
        params.searchKeyword = this.searchKeyword;
      }
      return params;
    },
    /**
     * 노드의 children 데이터로 자식 노드를 생성한다.
     * @author Ju
     * @param  {Array} children 자식 노드를 생성할 부모 노드 데이터 배열
     * @param  {[type]} tree    트리 객체
     */
    createChildNodes(children, tree) {
      forEach(children, (child) => {
        const node = tree.getNode(child.treeKey);
        if (!isEmpty(node) && !isEmpty(node.data.children)) {
          node.doCreateChildren(node.data.children);
          node.loaded = true;
          node.expanded = true;

          this.createChildNodes(node.data.children, tree);
        }
      });
    },
    /**
     * root 노드 기준으로 트리 데이터를 다시 조회한다.
     * @author Ju
     */
    reloadRootNode() {
      const store = this.$refs[this.treeRef].store;
      store.remove(store.root.childNodes[0]);
      store.load(store.root, (data) => {
        store.root.doCreateChildren(data);
      });
    },
    /**
     * 모든 트리 노드의 loaded를 true로 변경한다.
     * 검색된 결과 트리 노드를 펼칠 수 없도록 한다.
     * NOTE: leaf property 처럼 data 객체에서 loaded 값을 설정할 수 있는 경우 검색된 결과 데이터에 loaded를 true로 전달하도록 하고 해당 function은 deprecated한다.
     * @author Ju
     */
    setLoadedStatusToAllTreeNodes() {
      const root = this.$refs[this.treeRef].root;
      this.setLoadedStatusToNodes(root.childNodes);
    },
    /**
     * 트리 노드의 loaded를 true로 변경한다.
     * @author Ju
     * @param  {Array} nodes [description]
     */
    setLoadedStatusToNodes(nodes) {
      forEach(nodes, (node) => {
        node.loaded = true;
        if (!isEmpty(node.childNodes)) {
          this.setLoadedStatusToNodes(node.childNodes);
        }
      });
    },
    /* Override */
    /* eslint-disable no-unused-vars */
    filterTree(keyword) {
      // 각 동적 트리에 맞게 오버라이드한다.
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/tree/dynamic-tree.js